<dialog-popup
    #dialog
    [title]="'Reset Start Page'"
    [isPrimaryButtonEnabled]="true"
    [isSecondaryButtonEnabled]="true"
    primaryButtonName="Cancel"
    (primaryButtonClicked)="dialog.closeDialog()"
    secondaryButtonName="Reset"
    (secondaryButtonClicked)="openConfirmationDialogPopup()"
    [displayWarningIcon]="true"
>
    <div class="dialog-content-wrapper">
        <p>
            Are you sure you want to reset your Start Page?
            Resetting will permanently remove all your customizations including folders, bookmarks and collections.
        </p>
    </div>
</dialog-popup>

<reset-start-page-confirmation-dialog/>
